import { cardAspectRatio } from '../../theme/tokens';

export interface ImageSizing {
  width?: number;
  aspectRatio?: string;
}

export type ImageTransform = (src: string, sizing?: ImageSizing) => string;

export type CardSize = 'small' | 'large';

export const defaultCardAspectRatio = (size: CardSize) =>
  size === 'small' ? cardAspectRatio.compact : cardAspectRatio.listing;

const WIDEST_RENDERED_CARD_WIDTH: Record<CardSize, number> = { large: 800, small: 400 };

export const THUMBNAIL_IMAGE_SIZING: ImageSizing = { width: 240, aspectRatio: '1:1' };

const toRatioValue = (ratio: string): number => {
  const [width, height] = ratio.split(/[:/]/).map(Number);
  return width > 0 && height > 0 ? width / height : Infinity;
};

const tallestRenderedRatio = (size: CardSize, aspectRatio?: string, mobileAspectRatio?: string) => {
  const { desktop, mobile } = defaultCardAspectRatio(size);
  const tallest = [aspectRatio ?? desktop, mobileAspectRatio ?? aspectRatio ?? mobile].reduce(
    (a, b) => (toRatioValue(b) < toRatioValue(a) ? b : a)
  );
  return toRatioValue(tallest) === Infinity ? desktop : tallest;
};

export const resolveCardImageSizing = (
  size: CardSize = 'large',
  aspectRatio?: string,
  mobileAspectRatio?: string
): ImageSizing => ({
  width: WIDEST_RENDERED_CARD_WIDTH[size],
  aspectRatio: tallestRenderedRatio(size, aspectRatio, mobileAspectRatio).replace(/\s*\/\s*/, ':'),
});

export const CARD_IMAGE_SIZING: ImageSizing = resolveCardImageSizing('large');
